import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
`

export const BoxItem = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
`

export const BoxText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
`

export const Circle = styled.div`
  padding: 16px;
  border-radius: 50%;
  background: #FFF2EE;
`

export const Title = styled.h2`
  font-family: 'Open Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  color: #222;
  margin-bottom: 0;
`

export const SubBlock = styled.div`
  display: flex;
  flex-direction: column;
`

export const SubTitle = styled.h3`
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #555;
  margin-bottom: 0;
`

export const SubItem = styled.span`
  font-family: 'Open Sans';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: #555;
  margin-bottom: 0;
`

export const SkeletonCard = styled(Skeleton)`
    width: 300px;
    height: ${({ height }) => `height: ${height}px;`};
`
